<template>
  <MenuRef :iShow="showColor" :openKeys="SubMenu">
    <div class="user">
      <div class="search-cond">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">用户名:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="searchDataDetail.realname" />
          </div>
          <div class="search-item">
            <div class="tol-title">手机号:</div>
            <a-input style="width: 434px; height: 40px; flex: 1 1 0%" v-model="searchDataDetail.phone" />
          </div>
          <div class="search-item" style="justify-content: flex-end">
            <div class="btn-cond">
              <div>
                <a-button @click="reset" class="search-normal"> 重置 </a-button>
                <a-button class="search-btn" :style="{ marginLeft: '24px' }" @click="searchData">
                  查询
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="user-box">
        <div class="user-view">
          <div class="tol-item">
            <a-button class="search-btn" @click="addUser()"> 新增 </a-button>
          </div>
        </div>
        <div class="user-table" ref="tableContainer">
          <a-config-provider :locale="locale">
            <div>
              <a-table :customRow="customRow" class="user-table" ref="table" size="small" :columns="columns"
                :data-source="tolInformation" :rowKey="(record, index) => {
                  return index;
                }
                  " :pagination="pagination"></a-table>
            </div>
          </a-config-provider>
        </div>
      </div>
      <a-modal :title="title" :visible="isModalVisible" :ok-text="'确定'" :cancel-text="'取消'" @ok="handleOk"
        @cancel="handleCancel">
        <a-spin :spinning="loading" tip="数据保存中...">
          <a-form :form="form">
            <a-form-item label="用户名" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-model="form.realname" />
            </a-form-item>
            <a-form-item label="用户昵称" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-model="form.nickname" />
            </a-form-item>
            <a-form-item label="密码" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-password v-model="form.password" />
              <a-alert v-if="passwordMsg" type="error" :message="`用户密码是必填的!`" show-icon />
            </a-form-item>
            <a-form-item label="手机号" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-model="form.phone" />
              <a-alert v-if="phoneMsg" type="error" :message="`用户手机号是必填的!`" show-icon />
            </a-form-item>
            <a-form-item label="性别" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select v-model="form.gender">
                <a-select-option value="男">男</a-select-option>
                <a-select-option value="女">女</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="角色" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select v-model="form.role" @change="handleRoleChange">
                <a-select-option v-for="role in roles" :key="role.id" :value="role.id">
                  {{ role.name }}
                </a-select-option>
              </a-select>
              <a-alert v-if="showSupervisorAlert" type="error" :message="`请先添加${supervisorType}!`" show-icon>
              </a-alert>
            </a-form-item>
            <!-- 动态显示的下拉框 -->
            <a-form-item v-if="shouldShowParentDropdown" :label="parentLabel" :label-col="labelCol"
              :wrapper-col="wrapperCol">
              <a-select v-model="form.parentId" @change="changeParent">
                <a-select-option v-for="parent in parentOptions" :key="parent.id" :value="parent.id">
                  {{ parent.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item label="账号类型" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select v-model="form.type">
                <a-select-option :value="1">客户端</a-select-option>
                <a-select-option :value="2">管理端</a-select-option>
              </a-select>
            </a-form-item> -->
            <a-form-item label="账号状态" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select v-model="form.isActive">
                <a-select-option :value="true">启用</a-select-option>
                <a-select-option :value="false">停用</a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </a-spin>
      </a-modal>
    </div>
  </MenuRef>
</template>

<script>
import moment from "moment";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { getUserList, getAllUsers, upsertUser, deleteUser } from "@/api";
import MenuRef from "./common/MenuRef";

export default {
  components: {
    MenuRef,
  },
  data() {
    return {
      getShow: true,
      SubMenu: ["sub-system"],
      showColor: ["4"],
      title: "新增用户",
      isModalVisible: false,
      loading: false,
      searchDataDetail: {
        realname: "",
        phone: ""
      },
      form: {
        openid: "",
        sessionKey: "",
        phone: "",
        password: "",
        salt: "",
        nickname: "",
        gender: "",
        imgUrl: "",
        contact: "",
        realname: "",
        isActive: true,
        type: 2,
        role: 2,
        parentId: "",
        parentName: "",
        isPush: false,
        companyId: "",
        userAddresss: [],
        userTokens: [],
        orders: [],
        logs: [],
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      showSupervisorAlert: false,
      supervisorType: "",
      locale: zhCN,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      indexNum: 1,
      tolInformation: [],
      roles: [
        { id: 1, name: "客户" },
        { id: 2, name: "管理员" },
        { id: 3, name: "财务" },
        { id: 4, name: "经理" },
        { id: 5, name: "运作主管" },
        { id: 6, name: "运作" },
        { id: 7, name: "电销主管" },
        { id: 8, name: "电销" },
        { id: 9, name: "面销主管" },
        { id: 10, name: "面销" },
      ],
      parentOptions: [],
      parentLabel: "",
      parentMapping: {
        6: {
          label: "运作主管",
          options: [],
        },
        8: {
          label: "电销主管",
          options: [],
        },
        10: {
          label: "面销主管",
          options: [],
        },
      },
      columns: [
        {
          title: "序号",
          key: "index",
          align: "center",
          customRender: (text, record, index) =>
            `${(this.indexNum - 1) * this.indexNum + index + 1}`,
        },
        {
          title: "用户名",
          align: "center",
          customRender: (text, record, index) => {
            return record.realname || "/";
          },
        },
        {
          title: "用户昵称",
          align: "center",
          customRender: (text, record, index) => {
            return record.nickname || "/";
          },
        },
        {
          title: "手机号",
          align: "center",
          customRender: (text, record, index) => {
            return record.phone || "/";
          },
        },
        {
          title: "性别",
          align: "center",
          customRender: (text, record, index) => {
            return record.gender || "/";
          },
        },
        {
          title: "角色",
          align: "center",
          customRender: (text, record, index) => {
            let msg = "";
            this.roles.forEach((item) => {
              if (record.role == item.id) {
                msg = item.name;
              }
            });
            return msg || "/";
          },
        },
        // {
        //   title: "账号类型",
        //   align: "center",
        //   customRender: (text, record, index) => {
        //     return record.type == 1 ? "客户端" : "管理端";
        //   },
        // },
        {
          title: "账号状态",
          align: "center",
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h("a-switch", {
              style: {
                width: "60px",
                height: "24px",
              },
              props: {
                checked: record.isActive,
                checkedChildren: "启用",
                unCheckedChildren: "停用",
              },
              on: {
                // change: () => this.handleSwitchChange(record),
              },
            });
          },
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          customRender: (text, record, index) => {
            let h = this.$createElement;
            return h("div", [
              h(
                "span",
                {
                  style: {
                    cursor: "pointer",
                    color: "#6699FF",
                    marginRight: "24px",
                  },
                  on: {
                    click: () => {
                      this.isModalVisible = true;
                      this.form = { ...record };
                    },
                  },
                },
                "修改"
              ),
              h(
                "span",
                {
                  attrs: {
                    type: "text",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#FF4D4D",
                  },
                  on: {
                    click: () => {
                      this.deleteData(record);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
          align: "center",
        },
      ],
      tableHeight: 259,
      // 初始化
      dataCount: 0,
      // 每页显示多少条
      pageSize: 15,
      pagination: {
        pageNo: 1,
        pageSize: 15, // 默认每页显示数量
        showSizeChanger: false, // 显示可改变每页数量
        showQuickJumper: true,
        pageSizeOptions: ["15", "20", "30", "50"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
        size: "middle",
      },
      phoneMsg: false,
      passwordMsg: false,
      userList: [],
    };
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    addUser() {
      this.isModalVisible = true;
    },
    handleOk() {
      this.phoneMsg = false;
      this.passwordMsg = false;
      if (!this.form.phone && !this.form.password) {
        this.phoneMsg = true;
        this.passwordMsg = true;
        return;
      }

      if (!this.form.phone) {
        this.phoneMsg = true;
        return;
      }

      if (!this.form.password) {
        this.passwordMsg = true;
        return;
      }

      this.loading = true;
      upsertUser(this.form).then((res) => {
        if (res.statusCode == 200) {
          this.loading = false;
          this.$Message.success("添加成功！");
          this.basicsData();
          this.handleCancel();
        } else {
          let message = "添加失败！";
          if (res.message) {
            message = res.message;
          }
          this.$Message.error(message);
          this.loading = false;
        }
      });
    },
    handleCancel() {
      this.isModalVisible = false;
      this.phoneMsg = false;
      this.passwordMsg = false;
      this.form = {
        openid: "",
        sessionKey: "",
        phone: "",
        password: "",
        salt: "",
        nickname: "",
        gender: "",
        imgUrl: "",
        contact: "",
        realname: "",
        isActive: true,
        type: 2,
        role: 2,
        parentId: "",
        parentName: "",
        isPush: false,
        companyId: "",
        userAddresss: [],
        userTokens: [],
        orders: [],
        logs: [],
      };
    },
    deleteData(record) {
      let list = [{ id: record.id }];
      this.$Modal.confirm({
        title: "操作提醒！！！",
        content: "您确定将该行删除么？",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          deleteUser(list).then((res) => {
            if (res.statusCode == 200) {
              this.$Message.success("数据删除成功！");
              this.basicsData();
            } else {
              this.$Message.error("数据删除失败！");
            }
          });
        },
        onCancel: () => {
          this.$message.info("您已取消操作！");
        },
      });
    },
    handleRoleChange(value) {
      this.parentOptions = [];
      if ([6, 8, 10].includes(value)) {
        // 使用 filter 和 map 简化
        this.parentOptions = this.userList
          .filter((item) => item.role === value - 1)
          .map((item) => ({
            id: item.id,
            name: item.realname || item.nickname,
          }));

        // 使用 switch 简化角色类型判断
        switch (value - 1) {
          case 5:
            this.parentLabel = "运作主管";
            break;
          case 7:
            this.parentLabel = "电销主管";
            break;
          case 9:
            this.parentLabel = "面销主管";
            break;
          default:
            this.parentLabel = "";
        }

        // 检查是否需要显示警告
        this.showSupervisorAlert = this.parentOptions.length === 0;
        this.supervisorType = this.parentLabel;
      } else {
        this.parentOptions = [];
        this.parentLabel = "";
        this.showSupervisorAlert = false;
        this.supervisorType = "";
      }
    },
    changeParent(value) {
      this.parentOptions.find((item) => value === item.id);
    },
    customRow(record, index) {
      return {
        style: {
          cursor: "pointer",
        },
        on: {
          // 鼠标单击行
          click: (event) => { },
        },
      };
    },
    async basicsData() {
      let params = {
        page: this.pagination.pageNo,
        size: this.pagination.pageSize,
        type: 2,
        realname: this.searchDataDetail.realname,
        phone: this.searchDataDetail.phone
      };
      await getUserList(params).then((res) => {
        if (res.data.list.length > 0) {
          this.tolInformation = res.data.list;
          this.dataCount = res.data.total;
          this.pagination.total = this.dataCount;
        } else {
          this.tolInformation = [];
          this.dataCount = 0;
          this.pagination.total = 0;
        }
      });
    },
    getAllUser() {
      getAllUsers().then((res) => {
        if (res.data.list.length >= 0) {
          this.userList = res.data.list;
        }
      });
    },
    async onPageChange(page) {
      this.pagination.pageNo = page;
      this.pagination.current = page;
      await this.basicsData();
    },
    searchData() {
      this.basicsData();
    },
  },
  mounted() {
    this.basicsData();
    this.getAllUser();
  },
  computed: {
    shouldShowParentDropdown() {
      return (
        [6, 8, 10].includes(this.form.role) && this.parentOptions.length > 0
      );
    },
  },
  watch: {
    // 表格高度自适应
    tolInformation: function (newVal, oldVal) {
      console.log('aaaaaa', newVal);
      if (newVal.length == 0) {
        document.getElementsByClassName(
          "ant-spin-nested-loading"
        )[0].style.height = 40 + "px";
      } else {
        if (newVal.length != this.pageSize) {
          document.getElementsByTagName("table")[0].style.height = 0 + "px";
        } else {
          document.getElementsByClassName(
            "ant-spin-nested-loading"
          )[0].style.height = 100 + "%";
          document.getElementsByTagName("table")[0].style.height = 100 + "%";
        }
      }
    },
  },
};
</script>

<style lang="less">
.user {
  height: 100%;
  width: 100%;

  .search-btn {
    background: #14cc76;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    border-color: #14cc76;
    width: 80px;
    height: 40px;
  }

  .search-btn:hover,
  .search-btn:active,
  .search-btn:focus {
    background: #14cc76;
    border-radius: 4px;
    color: #ffffff;
    border-color: #14cc76;
  }

  .search-normal {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #969998;
    border-color: #e3e6e4;
    width: 80px;
    height: 40px;
  }

  .search-normal:hover,
  .search-normal:active,
  .search-normal:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-delete {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ff6b4d;
    border-color: #ff6b4d;
    width: 80px;
    height: 40px;
  }

  .search-delete:hover,
  .search-delete:active,
  .search-delete:focus {
    background: transparent;
    border-radius: 4px;
    color: #ff6b4d;
    border-color: #ff6b4d;
  }

  .search-cond {
    width: 100%;
    height: 100px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px;

    .search-input {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .search-item {
        width: calc(100% / 3);
        display: flex;
        align-items: center;

        .tol-title {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #313332;
          line-height: 22px;
          font-style: normal;
          margin-right: 10px;
        }
      }
    }

    .search-button {
      margin-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;

      .btn-cond {
        width: calc(100% / 3);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }

  .user-box {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;

    .title {
      display: block;
      border-bottom: solid 1px #384057;
      padding-bottom: 10px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M;
      line-height: 28px;
      text-align: left;
    }

    .user-view {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
      width: 100%;
      height: 42px;

      .tol-item {
        display: flex;
        align-items: center;

        .tol-add {
          margin-left: 20px;
        }

        .tol-title {
          margin-right: 6px;
          overflow-wrap: break-word;
          color: rgba(207, 214, 230, 1);
          font-size: 16px;
          font-family: Roboto-Medium;
        }

        .Select-style {
          width: 336px;
          height: 40px;
        }
      }
    }

    .user-table {
      height: calc(~"100% - 182px");
      padding-top: 4px;

      // 表格
      .user-table {
        height: 100%;

        .ant-checkbox-inner {
          background-color: transparent;
          border-color: rgba(132, 161, 219, 1);
        }

        //  点击时选框样式
        .ant-checkbox-wrapper-checked {
          .ant-checkbox-checked {
            background: #3384ff;
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.ant-select-selection--single {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/.ant-select-selection--multiple .ant-select-selection__rendered {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}

/deep/ .ant-btn {
  width: 80px;
  height: 40px;
  font-size: 16px;
}

/deep/.ant-input {
  height: 40px !important;
}

/deep/ .ant-table-thead {
  background: #f0f0f0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #313332;
}

/deep/.ant-table-small>.ant-table-content>.ant-table-body {
  margin: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #313332;
  line-height: 22px;
}

/deep/.ant-switch-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-wrapper-checked .ant-checkbox-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-inner {
  border: 1px solid #14cc76;
}

/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background: #14cc76;
}

/deep/ .ant-checkbox-checked::after {
  border: 1px solid #14cc76;
}

/deep/ .ant-spin-nested-loading {
  height: unset !important;
}

/deep/.ant-alert-message {
  color: red;
}
</style>
